// router/globalViewRouter.js

import globalViewVue from '@/views/global-view/global-view.vue'
import globalViewDashboard from '@/views/global-view/global-dashboard-view.vue'
import globalViewNoftifiaction from '@/views/global-view/global-notification-view.vue'

import globalViewDashboardSettings from '@/views/global-view/settings/global-dashboard-settings-view.vue'
import globalViewDashboardCharts from '@/views/global-view/settings/global-dashboard-charts-view.vue'
import globalViewDashboardIframe from '@/views/global-view/settings/global-dashboard-iframe-view.vue'


import globalOfflineView from '@/views/global-view/global-offline-view'
import chartDetailsDialog from '@/views/dialog-views/chart-details-dialog.vue'

import globalViewAdminDashboard from '@/views/global-view/global-admin-dashboard-view.vue'

export default {
    name: 'main-global-view', 
    path: '/main/global', 
    redirect: { name: 'main-global-notification' }, 
    component: globalViewVue, 
    children: [
        { name: 'main-global-dashboard', path: '/main/global/dashboard/:id', props: true, component: globalViewDashboard, children: [
        
                { name: 'main-global-dashboard-settings', path: '/main/global/dashboard/:id/settings', props: true, component: globalViewDashboardSettings, },
                { name: 'main-global-dashboard-charts', path: '/main/global/dashboard/:id/charts', props: true, component: globalViewDashboardCharts, },
                { name: 'main-global-dashboard-iframe', path: '/main/global/dashboard/:id/iframe', props: true, component: globalViewDashboardIframe, },
                
                { name: 'main-global-dashboard-chart-details', path: '/main/global/dashboard/:id/chart-details/:chartId/:maschineId/:type/:html_id', props: true, component: chartDetailsDialog, },

            ] 
        },
        { name: 'main-global-notification', path: '/main/global/notification/:header?', props: true, component: globalViewNoftifiaction, },
    
        { name: 'main-global-offline', path: '/main/global/offline', props: true, component: globalOfflineView, },
        { name: 'main-global-admin-dashboard', path: '/main/global/admin-dashboard', component: globalViewAdminDashboard }
    
    ]
            
}